import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// Define route-to-title mappings
var pageTitleMappings = {
    '/insights/home': 'Home',
    '/insights/academic_office': 'Academics & Offices',
    '/insights/settings': 'Settings',
    '/insights/planning/home': 'Planning',
    '/insights/unauthorized': 'Unauthorized',
};
// Pattern-based mappings for dynamic routes
var getPatternBasedTitle = function (pathname) {
    if (pathname.match(/^\/insights\/institution\/[^\/]+$/)) {
        return 'Institution Details';
    }
    if (pathname.match(/^\/insights\/institution\/[^\/]+\/organization\/[^\/]+$/)) {
        return 'Organization Details';
    }
    if (pathname.match(/^\/insights\/institution\/[^\/]+\/program\/[^\/]+$/)) {
        return 'Program Details';
    }
    if (pathname.match(/^\/insights\/planning\/institution\/[^\/]+\/organization\/[^\/]+$/)) {
        return 'Planning - Organization';
    }
    if (pathname.match(/^\/insights\/.*\/html$/)) {
        return 'Export View';
    }
    return null;
};
export var usePageTitle = function (customTitle) {
    var location = useLocation();
    useEffect(function () {
        var updateTitle = function () {
            var pageTitle = 'Insights Hub'; // Default fallback
            if (customTitle) {
                // If a custom title is provided, use it
                pageTitle = "".concat(customTitle, " - Insights Hub");
            }
            else {
                // Try to get title from route mappings
                var mappedTitle = pageTitleMappings[location.pathname];
                if (mappedTitle) {
                    pageTitle = "".concat(mappedTitle, " - Insights Hub");
                }
                else {
                    // Try pattern-based matching
                    var patternTitle = getPatternBasedTitle(location.pathname);
                    if (patternTitle) {
                        pageTitle = "".concat(patternTitle, " - Insights Hub");
                    }
                    else {
                        // Try to extract from page header element
                        var titleElement = document.querySelector('.page-header .title');
                        if (titleElement === null || titleElement === void 0 ? void 0 : titleElement.textContent) {
                            pageTitle = "".concat(titleElement.textContent, " - Insights Hub");
                        }
                    }
                }
            }
            document.title = pageTitle;
        };
        // Update title immediately
        updateTitle();
        // Also update after a short delay to catch dynamically loaded content
        var timeoutId = setTimeout(updateTitle, 100);
        return function () { return clearTimeout(timeoutId); };
    }, [location.pathname, customTitle]);
};
